import { TaskApiResponseResult } from '@/store/modules/taskView/types';
import { formatDataValue } from './format';
import { Task } from '@/types/Task';

export const createTasks = (tasks: TaskApiResponseResult[]) => {
  return tasks.map(
    task =>
      ({
        clientId: formatDataValue(task.clientId),
        dateCreated: formatDataValue(task.dateCreated, {
          overrideDateFormat: true,
        }),
        dateDue: formatDataValue(task.dateDue, { overrideDateFormat: true }),
        opportunityName: formatDataValue(task.opportunityName),
        responsibleUserId: task.responsibleUserId.dataValue
          ? formatDataValue(task.responsibleUserId)
          : '',
        taskId: formatDataValue(task.taskId),
        taskType: formatDataValue(task.taskType),
        taskStatus: formatDataValue(task.taskStatus),
        expectedAum: formatDataValue(task.expectedAum),
      } as Task)
  );
};
